<t4-list-view #listVw [options]="listOptions" (onDataRequest)="doPage($event)">
  <ng-container *t4ListItem="let item">
    @switch (item.ProductType) {
      @case (ProductTypeEnum.Ticket) {
        @if (item.PassePartoutName == null) {
          <td [class.strikethrough]="item.IsCredited">
            {{item.EventDate | localDateTime }} - {{item.EventName}}
          </td>
        }
        @if (item.PassePartoutName != null) {
          <td [class.strikethrough]="item.IsCredited">{{ item.PassePartoutName | replaceOnEmpty:''}}</td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Barcode}}</td>
        @if (!item.HasRemovedPositions) {
          <td [class.strikethrough]="item.IsCredited">{{item.ParentSectionName}} / {{item.RowNumber | replaceOnEmpty}}
          / {{item.SeatNumber | replaceOnEmpty}}</td>
        }
        @if (item.HasRemovedPositions) {
          <td [class.strikethrough]="item.IsCredited">{{'SALES-ENTITY-MODIFICATION.LISTVIEW.POSITION.FREED' | translate}}</td>
        }
        <td [class.strikethrough]="item.IsCredited">{{ item.SelectedSingleEntranceName | replaceOnEmpty:'[Standaard]' }}</td>
        <td [class.strikethrough]="item.IsCredited">{{ item.TicketText | replaceOnEmpty:'[Standaard]' }}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.TicketTypeName}}</td>
        <td [class.strikethrough]="item.IsCredited"><t4-customer-identification-control [isIbaActive]="isIbaActive" [showCustomerNumber]="true" [customer]="constructOrderCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
        @if (hasTicketStatus && !isInEditMode) {
          <td>@if ((!isSecondaryOrder || !item.IsCredited) && item.TicketStatus) {
            <t4-ticket-iba-status [ticket]="item"></t4-ticket-iba-status>
          }</td>
        }
        @if (!isSecondaryOrder) {
          <td [class.strikethrough]="item.IsCredited">{{!item.IsCredited ? item.PriceVariationName : '-'}}</td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency}}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @case (ProductTypeEnum.Membership) {
        <td [class.strikethrough]="item.IsCredited">{{ item.MembershipName | replaceOnEmpty}}</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited"><t4-customer-identification-control [isIbaActive]="isIbaActive" [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
        @if (!isSecondaryOrder) {
          <td [class.strikethrough]="item.IsCredited">{{!item.IsCredited ? item.PriceVariationName : '-'}}</td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency}}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @case (ProductTypeEnum.DeliveryMethod) {
        <td [class.strikethrough]="item.IsCredited">{{'T4.ORDERDETAILS.ORDERLINES.DELIVERY-COST' | translate}}</td>
        <td colspan="6"></td>
        @if (hasTicketStatus && !isInEditMode) {
          <td></td>
        }
        @if (!isSecondaryOrder) {
          <td></td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency}}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @case (ProductTypeEnum.PaymentMethod) {
        <td [class.strikethrough]="item.IsCredited">{{'T4.ORDERDETAILS.ORDERLINES.MARKUP-PAYMENTMETHOD' | translate}}</td>
        <td colspan="6"></td>
        @if (hasTicketStatus && !isInEditMode) {
          <td></td>
        }
        @if (!isSecondaryOrder) {
          <td></td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency}}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @case (ProductTypeEnum.CrossSellProduct) {
        <td colspan="7" [class.strikethrough]="item.IsCredited">{{ item.CrossSellProductName | translate }} ({{ item.CrossSellProductVariantName | translate }}) {{item.EventName}}</td>
        @if (hasTicketStatus && !isInEditMode) {
          <td></td>
        }
        @if (!isSecondaryOrder) {
          <td></td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency }}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency }}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency }}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @case (ProductTypeEnum.MatchDayPass) {

        <td [class.strikethrough]="item.IsCredited">{{ item.MatchDayPassName | replaceOnEmpty}}</td>
        <td [class.strikethrough]="item.IsCredited">{{ item.SectorName }}</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">-</td>
        <td [class.strikethrough]="item.IsCredited">Flexplan</td>
        <td [class.strikethrough]="item.IsCredited"><t4-customer-identification-control [isIbaActive]="isIbaActive" [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
        @if (hasTicketStatus && !isInEditMode) {
          <td></td>
        }
        @if (!isSecondaryOrder) {
          <td [class.strikethrough]="item.IsCredited">{{!item.IsCredited ? item.PriceVariationName : '-'}}</td>
        }
        <td [class.strikethrough]="item.IsCredited">{{item.Price | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.VAT | localCurrency}}</td>
        <td [class.strikethrough]="item.IsCredited">{{item.Total | localCurrency}}</td>
        @if (isInEditMode) {
          <td>
            @if (showEditButtons(item)) {
              <button (click)="actionClick('edit', item)" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
            }
            @if (showEditButtons(item)) {
              <button (click)="actionClick('credit', item)" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            }
          </td>
        }
      }
      @default {
        <td colspan="11">
          <span class="fas fa-exclamation-triangle"></span>
          <span class="mx-2">{{'T4.ORDERDETAILS.ORDERLINES.CANNOTSHOWLINE' | translate}}</span>
          <span class="fas fa-exclamation-triangle"></span>
        </td>
      }
    }
  </ng-container>
</t4-list-view>
